import { get } from 'lodash';

import { getErrorMessage } from './api-normalizers';

export const isLoading = (state, stateChunkNames = []) => {
  return stateChunkNames.some(stateChunkName => {
    return get(state, `${stateChunkName}.loading`);
  });
};

export const hasError = (state, stateChunkNames = []) =>
  stateChunkNames.some(
    stateChunkName => !!get(state, `${stateChunkName}.error`),
  );

export const isLoadingCurrent = (stateChunk, id) => {
  const result = id && !get(stateChunk, 'current') && !get(stateChunk, 'error');

  return result;
};

export const getMessageFromError = (stateChunk, defaultMessage) =>
  stateChunk.error && getErrorMessage(stateChunk.error, defaultMessage);
